import { createTheme } from "@mui/material";
import { rootTheme } from "../../utils/theme";

export const theme = createTheme({
  typography: {
    ...rootTheme.typography,
    allVariants: {
      color: "#F8FAFF",
    },
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: '#003B6A',
          padding: 20
        }
      }
    },
  }})